export const ADMIN_REFRESH_STORAGE_KEY = "aivpn_admin_refresh_token";
